export const logoutUser = () => {
    localStorage.removeItem("LOGIN_RESPONSE");
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("expiresAt");
    localStorage.setItem("LOGGED_OUT", "true");
    setTimeout(() => {
        window.location.replace("/");
    }, 500);

};